import React, { Component } from "react";
import "./index.scss";
import { Typography } from "@material-ui/core";

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
  allExpanded?: boolean;
  sectionTitle?: string;
}

interface FAQState {
  openItems: number[];
}

export default class FAQ extends Component<FAQProps, FAQState> {
  public state = {
    openItems: [],
  };

  onItemClick = (itemIndex: number) => {
    const openItems: number[] = this.state.openItems;
    const index = openItems.indexOf(itemIndex);
    if (index < 0) {
      openItems.push(itemIndex);
    } else {
      openItems.splice(index, 1);
    }
    this.setState({ openItems: openItems });
  };

  render() {
    const openItems: number[] = this.state.openItems;
    const allExpanded = !!this.props.allExpanded;
    const half = Math.ceil(this.props.items.length / 2);

    return (
      <div className="faq-lists">
        {this.props.sectionTitle && (
          <Typography className="section-title" variant="h2" component="h2">
            {this.props.sectionTitle}
          </Typography>
        )}
        <ul className={`faq-list ${allExpanded ? " all-expanded" : ""}`}>
          {this.props.items.slice(0, half).map((i, index) => {
            const listIndex = parseInt(`1${index}`);
            const open = openItems.indexOf(listIndex) >= 0;
            return (
              <li key={listIndex} className={open || allExpanded ? "" : "open"}>
                <div className="question">
                  <Typography variant="body2">{i.question}</Typography>
                </div>
                <Typography
                  variant="body2"
                  className="answer"
                  dangerouslySetInnerHTML={{ __html: i.answer }}
                />
              </li>
            );
          })}
        </ul>
        <ul className={`faq-list ${allExpanded ? " all-expanded" : ""}`}>
          {this.props.items
            .slice(half, this.props.items.length)
            .map((i, index) => {
              const listIndex = parseInt(`2${index}`);
              const open = openItems.indexOf(listIndex) >= 0;
              return (
                <li
                  key={listIndex}
                  className={open || allExpanded ? "" : "open"}
                >
                  <div className="question">
                    <Typography variant="body2">{i.question}</Typography>
                  </div>
                  <Typography
                    variant="body2"
                    className="answer"
                    dangerouslySetInnerHTML={{ __html: i.answer }}
                  />
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}
